import { axios_institute_public } from "../../../../../../api/setup.intersepter";

import { PublicWebformStateDTO } from "./types";

export const CreateContact = (data: any) => {
  return axios_institute_public({
    method: "POST",
    url: `/studentContact`,
    data: data,
  });
};
// export const UpdateContact = (data: any) => {
//   return axios_institute_public({
//     method: "PUT",
//     url: `/studentContact?studentContactId=${data.id}&demoTiming=${data.demoTiming}`,
//   });
// };
export const GetPublicWebformById = (data: any) => {
  return axios_institute_public({
    method: "GET",
    url: `/getWebformById?webFormID=${data}`,
  });
};

export const GetCartInfo = (data: any) => {
  const { enquiryId, transactionId, signature } = data;
  return axios_institute_public({
    method: "GET",
    url: `/paymentCart?enquiryId=${enquiryId}&transactionId=${transactionId}&signature=${signature}`,
  });
};

export const InitiatePaymenrt = (data: any) => {
  return axios_institute_public({
    method: "POST",
    url: `/paymentCart?actionType=initiatePayment`,
    data: data,
  });
};
